import type { ReactNode } from 'react';
import { useState } from 'react';
import { styled } from 'styled-components';

import { Button } from '#/components/Button/Button';
import { colors, fontWeights } from '#/theme/theme';
import { isDefined } from '#/utils/functional/type';

const ToggleLinkHolder = styled.div`
  padding-bottom: 31px;

  &::before {
    content: '+ ';
    color: ${colors.brandBlue};
    font-weight: ${fontWeights.semiBold};
  }
`;

export const ToggleSection = styled(
  ({
    children,
    title,
    className,
    toggleQaId,
  }: {
    children: ReactNode;
    title?: string;
    className?: string;
    toggleQaId?: string;
  }) => {
    const [expanded, setExpanded] = useState(false);

    if (!isDefined(title)) return children;

    return (
      <div
        style={{ position: 'relative', paddingTop: 31 }}
        className={className}
      >
        <div>
          {expanded ? (
            children
          ) : (
            <ToggleLinkHolder>
              <Button
                type="button"
                variant="tertiary"
                onClick={() => setExpanded(!expanded)}
                qaId={toggleQaId}
                noPadding
                size="large"
              >
                {title}
              </Button>
            </ToggleLinkHolder>
          )}
        </div>
      </div>
    );
  },
)`
  &:last-child {
    &::after {
      opacity: 0;
    }
  }
`;
